import { Carousel, Col, Image, Row, Space } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { setProduct, setCarouselSelectedIndex } from '../../redux/slices/productCarouselSlice';


const ProductImagesCarousel = ({ selectedProduct }) => {

    const dispatch = useDispatch();


    const carouselRef = React.createRef();

    const handleItemClick = (index) => {
        carouselRef.current.goTo(index, false);
        dispatch(setCarouselSelectedIndex(index));
    };

    const handleBeforeChange = (currentIndex, nextIndex) => {
        dispatch(setCarouselSelectedIndex(nextIndex));
    };


    useEffect(() => {
        if (selectedProduct) {
            dispatch(setProduct(selectedProduct));
        }
    }, [selectedProduct, dispatch]);

    return (
        <div className="image-modal-main-carousel">
            <Carousel className="custom-carousel" ref={carouselRef} autoplay={true} dots={false} beforeChange={handleBeforeChange}>
                {selectedProduct.images.length > 0 ? (
                    selectedProduct.images.map((image, index) => (
                        <div key={index} className='product-slider-item'>
                            <Image preview={false} src={image.url} alt="" style={{borderRadius:'4px'}}/>
                        </div>
                    ))
                ) : (
                    <div>
                        <Image style={{borderRadius:'4px'}} preview={false} src={selectedProduct.image} alt="" />
                    </div>
                )}
            </Carousel>
            <Row gutter={[2.5, 2.5]} className='slider-preview'>
                <Space>
                    {selectedProduct ? (
                        selectedProduct.images.map((image, index) => (
                            <Col key={index} xs={24} sm={12} md={8} lg={6} className={index === 'carouselSelectedIndex' ? 'slider-preview-thumb selected' : 'slider-preview-thumb'}>
                                <Image preview={false} src={image.url} alt="" onClick={() => handleItemClick(index)} />
                            </Col>
                        ))
                    ) : (
                        <div></div>
                    )}
                </Space>
            </Row>
        </div>
    );
};
export default ProductImagesCarousel;
